import { useSelector } from "react-redux"
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { formatDinero } from "./../../../../utils/formatDinero"
const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
  });

const CabeceraPagos = () => {
    const classes = useStyles();
    const { cliente } = useSelector(store => store.calendario)
   
    return (
        <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">Total a Pagar</TableCell>
              <TableCell align="center">Num. Pagos</TableCell>
              <TableCell align="center">Pago Mensual</TableCell>
              <TableCell align="center">Pago Actual</TableCell>
              <TableCell align="center">Monto Acumulado</TableCell>
              <TableCell align="center">Saldo Disponible</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
                <TableCell align="center">{formatDinero(cliente?.paquete?.Monto_Paquete)}</TableCell>
                <TableCell align="center">{cliente?.paquete?.Numero_Pagos}</TableCell>
                <TableCell align="center">{formatDinero(cliente?.PagoMensual)}</TableCell>
                <TableCell align="center">{cliente?.PagoActual}</TableCell>
                <TableCell align="center">{formatDinero(cliente?.Suma)}</TableCell>
                <TableCell align="center">{formatDinero(cliente?.SaldoDisponible)}</TableCell>
              </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    )
}
export default CabeceraPagos